import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import HeaderMobileEducation from "./HeaderMobileEducation";
import ShortHeaderWithBackBtn from "./ShortHeaderWithBackBtn";

const Header = () => {

	const { isMobile } = true;

    return (

        <Routes>
            <Route  path='/blog' element={ !isMobile ? <HeaderMobileEducation /> : <HeaderMobileEducation />} />
            <Route  path='/blog/:title' element={ !isMobile ? <ShortHeaderWithBackBtn data={{setPadding: true}} /> : <ShortHeaderWithBackBtn data={{setPadding: true}} />} />

            {/*<Route  path='/' element={ !isMobile ? <HeaderMobileEducation /> : <HeaderMobileEducation />} />*/}
        </Routes>

    );
}

export default Header;